module.exports = __webpack_public_path__ + "img/facebook-round-white.1011dfab.svg";